import { render, staticRenderFns } from "./CarouselVue.vue?vue&type=template&id=49d1fa71&scoped=true"
import script from "./CarouselVue.vue?vue&type=script&lang=js"
export * from "./CarouselVue.vue?vue&type=script&lang=js"
import style0 from "./CarouselVue.vue?vue&type=style&index=0&id=49d1fa71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d1fa71",
  null
  
)

export default component.exports